// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__J0jqP","active":"Tab_active__kgkWd"};